import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GeneralButton } from '../../../../common/ui/GeneralButton';

type Props = {
    open: boolean;
    onClose: () => void;
    name: string;
    text: string;
};

const TextDialog = ({ open, onClose, name, text }: Props) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{name}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="subtitle1" gutterBottom>
                    Text:
                </Typography>
                {text ? (
                    <Typography variant="body2" sx={{ mb: 2 }}>{text}</Typography>
                ) : (
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        ({t("serviceModulesPage.folderServicePage.noText")})
                    </Typography>
                )}
            </DialogContent>
            <GeneralButton
                appVariant="secondary"
                onClick={onClose}
            >
                {t("buttons.close")}
            </GeneralButton>
        </Dialog>
    );
};

export default TextDialog;
